import { API } from "aws-amplify";

async function createRole(role: Role): Promise<Role> {
  try {
    const path: string = `/roles`;

    const tempRole: any = { ...role };
    delete tempRole.companyId;
    delete tempRole.id;
    const options = {
      body: tempRole,
      queryStringParameters: {  // OPTIONAL
        companyId: role.companyId,
      },
    };

    const data = await API.post(
      'api-service',
      path,
      options
    );


    return data.data as Role;
  } catch (error: any) {
    throw error;
  }
}

export default createRole;
